import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ExternalLink } from "lucide-react";
import "./B2BDashboardPayments.css";

const B2BDashboardPayments: React.FC = () => {
  useEffect(() => {
    // Redirect to gcbusiness.space after 3 seconds
    const redirectTimer = setTimeout(() => {
      window.open("https://gcbusiness.space", "_blank");
    }, 3000);

    return () => clearTimeout(redirectTimer);
  }, []);

  return (
    <div className="dashboard-payments-container">
      {/* Header */}
      <div className="dashboard-payments-header">
        <Link
          to="/gcb/dashboard"
          className="back-button"
        >
          <ArrowLeft size={20} />
          Back to Dashboard
        </Link>
        <div className="header-content">
          <h1>Corporate Payments Dashboard</h1>
          <p>Manage your enterprise payment solutions and track transactions</p>
        </div>
      </div>

      {/* Redirect Content */}
      <div className="empty-dashboard-content">
        <div className="empty-content-card">
          <h2>Redirecting to Corporate Payments</h2>
          <p>
            You will be automatically redirected to our corporate payments
            platform in a few seconds.
          </p>
          <p>
            If you are not redirected automatically, please click the button
            below:
          </p>
          <div className="redirect-actions">
            <a
              href="https://gcbusiness.space"
              target="_blank"
              rel="noopener noreferrer"
              className="redirect-button"
            >
              <ExternalLink size={16} />
              Go to Corporate Payments
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default B2BDashboardPayments;

